module.exports = __webpack_public_path__ + "static/media/Abbas-Ibrahim-RESUME-FSD.88b82d94.pdf";